import gqlClient from 'graphql-client';

const getToken = () => {
    try {
        return localStorage.getItem('token');
    } catch (e) {
        return '';
    }
};

export const getClient = () => {
    const token = getToken();
    return gqlClient({
        url: process.env.GRAPHQL_SERVER,
        headers: {
            authorization: `Bearer ${token}`,
        },
    });
};

export default getClient;
